import { SideAccessoryTypes } from '../../../../../../api/models';

export const sideAccessories = [
  { key: SideAccessoryTypes.Ridge, name: 'Coamă' },
  { key: SideAccessoryTypes.Gable, name: 'Fronton' },
  { key: SideAccessoryTypes.EavesBorder, name: 'Bordură streașină' },
  { key: SideAccessoryTypes.Gutter, name: 'Jgheab' },
  { key: SideAccessoryTypes.GutterHook, name: 'Cârlig jgheab' },
  { key: SideAccessoryTypes.SnowStopper, name: 'Opritor zăpadă' },
  { key: SideAccessoryTypes.RoofValley, name: 'Dolie' },
];
